import PermissionClassification from '@/util/enums/PermissionClassification';
import useAllowedPermission from '@/util/hooks/useAllowedPermission';
import { createContext, useContext, type ReactNode } from 'react';

type SupportModeContextValue = {
  isSupportMode: boolean;
  isLoading: boolean;
};

const SupportModeContext = createContext<SupportModeContextValue>({
  isSupportMode: false,
  isLoading: true
});

// eslint-disable-next-line react-refresh/only-export-components -- hook is the public API for this context
export const useSupportMode = () => useContext(SupportModeContext);

export function SupportModeProvider({ children }: { children: ReactNode }) {
  const { handleHasPermissionCheckFunction: hasAllowedPermission, isLoading } =
    useAllowedPermission();
  const isSupportMode = hasAllowedPermission(
    PermissionClassification.SupportCompanyContextSwitch
  );

  return (
    <SupportModeContext.Provider value={{ isSupportMode, isLoading }}>
      {children}
    </SupportModeContext.Provider>
  );
}
